import * as React from 'react';
import { Pager, PagerProps } from '@progress/kendo-react-data-tools';

export const CustomPager = (props: PagerProps) => {
  return (
    <Pager
      {...props}
      previousNext={true}
      buttonCount={10}
      className="custom-pager"
    />
  );
};
